<template>
  <div>
    <div class="my-5 pa-3">
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-row>
        <v-col>
          <v-btn @click="addAlamat = true" class="ma-2" tile color="success">
            <v-icon left>mdi-plus</v-icon>Tambah Alamat
          </v-btn>
        </v-col>
        <v-col>
          <v-text-field solo label="Cari Alamat atau Nama Penerima..." prepend-inner-icon="search"></v-text-field>
        </v-col>
      </v-row>
      <!-- <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg">
        <v-row align="center" justify="center">
          <v-col class="text-center" cols="12">
            <h1 class="display-1 font-weight-thin mb-4">Vuetify.js</h1>
            <h4 class="subheading">Build your application today!</h4>
          </v-col>
        </v-row>
      </v-parallax>-->
      <v-simple-table v-if="dataUser != null" fixed-header height="500">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left"></th>
              <th class="text-left">Penerima</th>
              <th class="text-left">Alamat Penerima</th>
              <th class="text-left">Daerah Pengiriman</th>
              <th class="text-left">Status Alamat</th>
              <th class="text-left">Aksi</th>
            </tr>
          </thead>
          <tbody v-for="data in dataAlamat" :key="data.id">
            <tr>
              <td>
                <v-checkbox v-model="selAlamat" :value="data.alamat_id" required></v-checkbox>
              </td>
              <td>
                <b>{{ data.penerima }}</b>
                <br />
                {{ data.penerimahp }}
              </td>
              <td>
                <b>{{ data.nama_alamat }}</b>
                <br />
                {{ data.jalan }}
              </td>
              <td>
                {{ data.provinsi }}, {{ data.kota }}
                <br />
                {{ data.kecamatan }}
                <br />
                {{ data.kodepos }}
                <br />Indonesia
              </td>
              <td v-if="data.status == 'UTAMA'">
                <v-chip small class="ma-2" color="red" label text-color="white">
                  <v-icon left>mdi-label</v-icon>
                  {{ data.status }}
                </v-chip>
              </td>
              <td v-if="data.status == 'LAINNYA'">
                <v-chip small class="ma-2" color="pink" label text-color="white">
                  <v-icon left>mdi-label</v-icon>
                  {{ data.status }}
                </v-chip>
              </td>
              <td>
                <v-btn class="mx-1" @click="ubahAlamat(data)" outlined small color="primary">Ubah</v-btn>
                <v-btn
                  class="mx-1"
                  @click="delAlamat(data.alamat_id)"
                  outlined
                  small
                  color="primary"
                >Hapus</v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <!--START ADD ALAMAT -->
    <v-dialog v-model="addAlamat" width="700">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Tambah Alamat
          <v-spacer></v-spacer>
          <v-btn @click="addAlamat = false" icon color="#90A4AE">
            <v-icon>fas fa-times-circle</v-icon>
          </v-btn>
        </v-card-title>
        <div class="pa-5">
          <v-form v-model="valid" lazy-validation ref="alamat">
            <div>
              <v-text-field
                hint="Contoh: Alamat Rumah, Kantor, Apartemen, Dropship"
                :persistent-hint="true"
                label="Nama Alamat"
                placeholder="Alamat Rumah"
                outlined
                required
                v-model="nama_alamat"
                :rules="[(v) => !!v || 'Harap di isi !']"
              ></v-text-field>
            </div>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  required
                  v-model="penerima"
                  :rules="[(v) => !!v || 'Harap di isi !']"
                  label="Nama Penerima"
                  placeholder="Nama penerima barang"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  hint="Angka [0-9], Contoh: 081234567890"
                  label="Nomor HP"
                  :placeholder="dataUser.handphone"
                  :persistent-hint="true"
                  outlined
                  v-model="penerimahp"
                  required
                  :rules="[(v) => !!v || 'Harap di isi !']"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  v-if="subDistrict"
                  v-model="kecamatan"
                  :rules="[(v) => !!v || 'Wajib di isi']"
                  :items="subDistrict"
                  item-text="Name"
                  item-value="Id"
                  label="Kota atau Kecamatan"
                  flat
                  hide-no-data
                  hide-details
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  required
                  :rules="[(v) => !!v || 'Harap di isi !']"
                  placeholder="Kode Pos"
                  label="Kodepos"
                  outlined
                  v-model="kodepos"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-textarea
              required
              v-model="alamat"
              :rules="[(v) => !!v || 'Harap di isi !']"
              placeholder="Alamat pengiriman barang"
              outlined
              autocomplete="text"
              label="Alamat"
            ></v-textarea>
          </v-form>
        </div>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="!valid" text @click="subAlamat()">Daftar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END ADD ALAMAT -->
    <!-- START EDIT ALAMAT -->
    <v-dialog v-model="edtAlamat" width="700">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Ubah Alamat
          <v-spacer></v-spacer>
          <v-btn @click="edtAlamat = false" icon color="#90A4AE">
            <v-icon>fas fa-times-circle</v-icon>
          </v-btn>
        </v-card-title>
        <div class="pa-5">
          <v-form v-model="valid" lazy-validation ref="alamat">
            <div>
              <v-text-field
                hint="Contoh: Alamat Rumah, Kantor, Apartemen, Dropship"
                :persistent-hint="true"
                label="Nama Alamat"
                placeholder="Alamat Rumah"
                outlined
                required
                v-model="editAlamat.nama_alamat"
                :rules="[(v) => !!v || 'Harap di isi !']"
              ></v-text-field>
            </div>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  required
                  v-model="editAlamat.penerima"
                  :rules="[(v) => !!v || 'Harap di isi !']"
                  label="Nama Penerima"
                  :placeholder="dataUser.nama"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  hint="Angka [0-9], Contoh: 081234567890"
                  label="Nomor HP"
                  :placeholder="dataUser.handphone"
                  :persistent-hint="true"
                  outlined
                  v-model="editAlamat.penerimahp"
                  required
                  :rules="[(v) => !!v || 'Harap di isi !']"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="8">
                <v-autocomplete
                  v-if="subDistrict"
                  v-model="kecamatan"
                  :rules="[(v) => !!v || 'Wajib di isi']"
                  :items="subDistrict"
                  item-text="Name"
                  item-value="Id"
                  label="Kota atau Kecamatan"
                  flat
                  hide-no-data
                  hide-details
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  required
                  :rules="[(v) => !!v || 'Harap di isi !']"
                  placeholder="50177"
                  label="Kodepos"
                  outlined
                  v-model="editAlamat.kodepos"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-textarea
              required
              v-model="editAlamat.jalan"
              :rules="[(v) => !!v || 'Harap di isi !']"
              placeholder="Jl. Selomas Barat I/88"
              outlined
              autocomplete="text"
              label="Alamat"
            ></v-textarea>
            <v-select
              v-model="editAlamat.status"
              :items="stats"
              :rules="[(v) => !!v || 'Harap di isi !']"
              label="Status Alamat"
              required
              outlined
            ></v-select>
          </v-form>
        </div>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="!valid" text @click="doneUbahAlamat(editAlamat)">Ubah</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END EDIT ALAMAT -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      status: null,
      kecamatan: null,
      kodepos: null,
      nama_alamat: null,
      penerima: null,
      alamat: null,
      penerimahp: null,
      provinsi: null,
      kota: null,
      valid: true,
      edtAlamat: false,
      addAlamat: false,

      loadCity: false,
      overlay: false,
      dataUser: [],
      editAlamat: [],
      dataAlamat: [],
      selAlamat: null,
      subDistrict: [],
      stats: ["UTAMA", "LAINNYA"],

      id: localStorage.getItem("user_id")
    };
  },
  mounted() {
    this.getDataUser();
    this.getKecamatan();
  },
  watch: {
    selAlamat() {
      alert(this.selAlamat);
    },
    provinsi(newVal) {
      this.getKota(newVal);
    }
  },

  methods: {
    getDataUser() {
      this.overlay = true;
      fetch(
        "http://meridinet.saebo.id:2082/Login/api/ViewUser/" +
          localStorage.getItem("user_id")
      )
        .then(response => response.json())
        .then(data => {
          this.overlay = false;
          this.dataUser = data;
          this.dataAlamat = data.alamat;
        });
    },
    validasi() {
      this.$refs.alamat.validate();
    },
    subAlamat() {
      this.overlay = true;

      if (this.$refs.alamat.validate()) {
        fetch("http://meridinet.saebo.id:2082/Login/api/tabel/addalamat", {
          method: "POST",
          body: JSON.stringify({
            userid: this.id,
            nama: "",
            nama_alamat: this.nama_alamat,
            alamat: this.alamat,
            handphone: "",
            subdistrict_id: this.kecamatan,
            kodepos: this.kodepos,
            status: "LAINNYA",
            penerimahp: this.penerimahp,
            penerima: this.penerima
          }),
          headers: {
            "Content-type": "application/json"
          }
        })
          .then(response => response.json())

          .then(data => {
            console.log(data);
            Swal.fire("Sukses", "Alamat ditambahkan", "success");
            this.overlay = false;
            this.addAlamat = false;
            this.getDataUser();
          });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Semua Kolom Wajib diisi"
        });
        this.overlay = false;
      }
    },
    delAlamat(e) {
      this.overlay = true;
      var x = parseInt(e);
      Swal.fire({
        title: "Anda yakin?",
        text: "Anda akan menghapus alamat",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya Hapus"
      }).then(result => {
        if (result.value) {
          fetch("http://meridinet.saebo.id:2082/Login/api/tabel/delalamat", {
            method: "POST",
            body: JSON.stringify({
              id: x
            }),
            headers: {
              "Content-type": "application/json",
              "Access-Control-Allow-Origin": "*"
            }
          })
            .then(response => {
              this.getDataUser();
              response.json();
            })
            .then(data => {
              console.log(data);
              if (data != "Not Found!") {
                this.overlay = false;
                Swal.fire("Deleted!", "Your file has been deleted.", "success");
              }
            });
        }
      });
    },
    ubahAlamat(data) {
      this.edtAlamat = true;

      this.editAlamat = data;
      this.status = data.status;
    },
    doneUbahAlamat(data) {
      Swal.fire({
        title: "Edit Alamat",
        text: "Pastikan data anda sudah benar!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, lanjutkan!"
      }).then(result => {
        if (result.value && this.$refs.alamat.validate()) {
          var x = parseInt(data.alamat_id);
          this.overlay = true;
          fetch("http://meridinet.saebo.id:2082/Login/api/tabel/updusers", {
            method: "POST",
            body: JSON.stringify({
              user_id: this.id,
              alamat_id: x,
              alamat: data.jalan,
              nama_alamat: data.nama_alamat,
              penerima: data.penerima,
              penerimahp: data.penerimahp,
              kecamatan: data.kecamatan,
              kodepos: data.kodepos,
              status: data.status
            }),
            headers: {
              "Content-type": "application/json"
            }
          })
            .then(response => response.json())
            .then(data => {
              console.log(data);
              (this.edtAlamat = false),
                (this.overlay = false),
                Swal.fire("Sukses!", "Alamat berhasil diubah!", "success");
            });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Semua Kolom Wajib diisi"
          });
          this.overlay = false;
        }
      });
    },
    getKecamatan() {
      fetch("http://meridinet.saebo.id:2082/Login/api/viewkecamatan")
        .then(response => response.json())
        .then(data => {
          this.subDistrict = data;
        });
    }
  }
};
</script>
